// Topbar.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import globalState from '../globalstate'; // Import the global state
import { observer } from 'mobx-react-lite'; // Import observer for MobX

const Topbar = observer(() => {
  const [isVerticalLayout, setIsVerticalLayout] = useState(window.innerWidth < window.innerHeight);
  const navigate = useNavigate();

  // Calculate the order count from globalState
  const orderCount = Object.keys(globalState.orderInCartMap).length;
  useEffect(() => {
    const handleResize = () => {
      setIsVerticalLayout(window.innerWidth < window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#EC3535',
        padding: isVerticalLayout ? '8px 8px' : '8px 64px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <button
        onClick={() => navigate('/adwav')}
        style={{
          border: 'none',
          background: 'none',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <img
          src="/assets/logo.png"
          alt="Logo"
          style={{ height: '24px', marginRight: '7px' }} // Modified: smaller logo and increased gap
        />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '5px' }}>
          <span style={{ fontSize: isVerticalLayout ? '10px' : '14px', color: 'white' }}>by Newswav</span>
        </div>
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: isVerticalLayout ? '8px' : '16px' }}>
      {!isVerticalLayout && (
  <button
    onClick={() => navigate('/adwav')}
    style={{
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
    }}
  >
    Home
  </button>
)}

        <button
          onClick={() => navigate('/adwav/booking')}
          style={{
            position: 'relative',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <img src="/assets/cart.png" alt="Cart" style={{ height: '40px' }} />
          {orderCount > 0 && (
            <div
              style={{
                position: 'absolute',
                top: isVerticalLayout ? '0px' : '-5px',
                right: isVerticalLayout ? '5px' : '-5px',
                background: 'white',
                color: '#EC3535',
                borderRadius: '50%',
                padding: '4px 8px',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              {orderCount}
            </div>
          )}
        </button>
      </div>
    </div>
  );
});

export default Topbar;
